import React, { useState } from 'react';
import { ProgressSpinner } from 'primereact/progressspinner';
import './Signup.css';
import { useNavigate } from 'react-router-dom';
import MomentumLogo from '../assets/images/momentum-ai-logo.png';
import axios from 'axios';


export default function Signup() {
  const [form, setForm] = useState({
    AgencyName: '',
    PrimaryContactName: '',
    AddressLine1: '',
    AddressLine2: '',
    Phone: '',
    Fax: '',
    EMail: '',
    ZipCode: '',
    StateName: '',
    City: '',
    LicenseNumber: '',
    DomesticLicenseStateName: '',
    CellPhone: '',
    Password: '',
    ConfirmPassword: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setError('');
  };

  function generateGuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      const r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    // Check all fields except ConfirmPassword
    for (const key in form) {
      if (key !== 'ConfirmPassword' && !form[key as keyof typeof form]) {
        setError('Please fill all required fields.');
        return;
      }
    }
    if (form.Password !== form.ConfirmPassword) {
      setError('Passwords do not match.');
      return;
    }

    setLoading(true);
    const payload = { ...form };

    try {
      const response = await axios.post(
        'https://momentumampapi-stage.insurancegig.com/api/account/signup',
        payload,
        { headers: { 'Content-Type': 'application/json' }, maxBodyLength: Infinity }
      );
      if (response.data && response.data.status === 1) {
        localStorage.setItem("authToken", response.data.authToken);
        localStorage.setItem("amsToken", response.data.amsToken);
        localStorage.setItem("userName", response.data.userName);
        localStorage.setItem("agency", response.data.agencyName);
        localStorage.setItem("NowcertsAgentId", response.data.nowCertsAgentId);
        localStorage.setItem("NCAgencyId", response.data.nowCertsAgencyId);
        const guid = generateGuid();
        navigate(`/supportbot/${guid}`);
      } else {
        setError(response.data && response.data.message ? response.data.message : 'Signup failed. Please try again.');
      }
    } catch (error) {
      setError('Signup failed. Please try again.');
      // Optionally log error: console.log(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="form-container">
      <form className="form-box" onSubmit={handleSubmit}>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: '32px' }}>
          <img src={MomentumLogo} alt="Momentum Logo" style={{ width: '160px', height: '40px', objectFit: 'contain', filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.08))' }} />
          <h2 className="form-title" style={{ marginTop: '24px' }}>Create your account</h2>
          <p style={{ color: '#6b7280', fontSize: '15px', textAlign: 'center', marginTop: '8px', fontWeight: '400' }}>Join Momentum AI to get started</p>
        </div>
        <div className="form-row">
          <div className="form-field">
            <label>Agency Name <span style={{ color: '#d32f2f' }}>*</span></label>
            <input type="text" name="AgencyName" value={form.AgencyName} onChange={handleChange} placeholder="Agency Name" />
          </div>
          <div className="form-field">
            <label>Primary Contact Name <span style={{ color: '#d32f2f' }}>*</span></label>
            <input type="text" name="PrimaryContactName" value={form.PrimaryContactName} onChange={handleChange} placeholder="Primary Contact Name" />
          </div>
          <div className="form-field">
            <label>Address Line 1 <span style={{ color: '#d32f2f' }}>*</span></label>
            <input type="text" name="AddressLine1" value={form.AddressLine1} onChange={handleChange} placeholder="Address Line 1" />
          </div>
        </div>
        <div className="form-row">
          <div className="form-field">
            <label>Address Line 2 <span style={{ color: '#d32f2f' }}>*</span></label>
            <input type="text" name="AddressLine2" value={form.AddressLine2} onChange={handleChange} placeholder="Address Line 2" />
          </div>
          <div className="form-field">
            <label>Phone <span style={{ color: '#d32f2f' }}>*</span></label>
            <input type="text" name="Phone" value={form.Phone} onChange={handleChange} placeholder="Phone" />
          </div>
          <div className="form-field">
            <label>Fax <span style={{ color: '#d32f2f' }}>*</span></label>
            <input type="text" name="Fax" value={form.Fax} onChange={handleChange} placeholder="Fax" />
          </div>
        </div>
        <div className="form-row">
          <div className="form-field">
            <label>Email <span style={{ color: '#d32f2f' }}>*</span></label>
            <input type="email" name="EMail" value={form.EMail} onChange={handleChange} placeholder="Email" />
          </div>
          <div className="form-field">
            <label>Zip Code <span style={{ color: '#d32f2f' }}>*</span></label>
            <input type="text" name="ZipCode" value={form.ZipCode} onChange={handleChange} placeholder="Zip Code" />
          </div>
          <div className="form-field">
            <label>State Name <span style={{ color: '#d32f2f' }}>*</span></label>
            <input type="text" name="StateName" value={form.StateName} onChange={handleChange} placeholder="State Name" />
          </div>
        </div>
        <div className="form-row">
          <div className="form-field">
            <label>City <span style={{ color: '#d32f2f' }}>*</span></label>
            <input type="text" name="City" value={form.City} onChange={handleChange} placeholder="City" />
          </div>
          <div className="form-field">
            <label>License Number <span style={{ color: '#d32f2f' }}>*</span></label>
            <input type="text" name="LicenseNumber" value={form.LicenseNumber} onChange={handleChange} placeholder="License Number" />
          </div>
          <div className="form-field">
            <label>Domestic License State Name <span style={{ color: '#d32f2f' }}>*</span></label>
            <input type="text" name="DomesticLicenseStateName" value={form.DomesticLicenseStateName} onChange={handleChange} placeholder="Domestic License State Name" />
          </div>
        </div>
        <div className="form-row">
          <div className="form-field">
            <label>Cell Phone <span style={{ color: '#d32f2f' }}>*</span></label>
            <input type="text" name="CellPhone" value={form.CellPhone} onChange={handleChange} placeholder="Cell Phone" />
          </div>
          <div className="form-field">
            <label>Password <span style={{ color: '#d32f2f' }}>*</span></label>
            <input type="password" name="Password" value={form.Password} onChange={handleChange} placeholder="Password" />
          </div>
          <div className="form-field">
            <label>Confirm Password <span style={{ color: '#d32f2f' }}>*</span></label>
            <input type="password" name="ConfirmPassword" value={form.ConfirmPassword} onChange={handleChange} placeholder="Confirm Password" />
          </div>
        </div>
        {error && <div className="form-error">{error}</div>}
        <div className="form-actions">
          <button type="submit" className="hub-btn hub-btn-signup" disabled={loading} style={{ position: 'relative', minWidth: 100 }}>
            {loading ? (
              <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8 }}>
                <ProgressSpinner style={{ width: 18, height: 18 }} strokeWidth="4" />
                Signing up...
              </span>
            ) : (
              'Sign up'
            )}
          </button>
          <button type="button" className="hub-btn hub-btn-signin" onClick={() => window.location.href = '/'} disabled={loading}>Back to Chat</button>
        </div>
      </form>
    </div>
  );
}
